module.exports = __webpack_public_path__ + "static/media/stage-product-icons-team.160d078e.svg";